import { api } from './apiService.js';
import { logout } from './session.js';
import { TemplateApp } from './app.js';
import defaultAvatar from '../images/default-avatar.svg'

export async function updateTopbarUI() {
    try {
        const userProfile = await api.userGetProfile();

        const userNameElement = document.getElementById('topbar-user-name');
        const userUsernameElement = document.getElementById('topbar-user-username');
        if (userNameElement) {
            userNameElement.textContent = userProfile.name || 'عضو خانواده ویکو';
        }
        if (userUsernameElement) {
            userUsernameElement.textContent = (userProfile.username || 'ID') + '@';
        }

        const avatarElements = document.querySelectorAll('.user-avatar');

        avatarElements.forEach(img => img.src = defaultAvatar);
        try {
            const avatarBlob = await api.userGetProfileAvatar();
            const avatarUrl = URL.createObjectURL(avatarBlob);
            avatarElements.forEach(img => img.src = avatarUrl);
        } catch (avatarError) {}

    } catch (error) {
        const isAuthError = error.status === 401 || (error.details && error.details.code === 101011);
        if (isAuthError) {
            logout();
        }
    }
}

function initLogout() {
    const logoutButton = document.getElementById('topbar-logout');
    if (logoutButton) {
        logoutButton.addEventListener('click', (event) => {
            event.preventDefault();
            logout();
        });
    }
}

export async function initMainLayout() {
    const template = new TemplateApp();
    template.templateInit();
    initLogout();

    await updateTopbarUI();

}
